import React, { useEffect } from 'react';

import { useAppSelector } from '../../store/hooks';
import { selectCities } from '../../store/slices/mapSlice';
import { useLazyGetMapInitDataQuery } from '../../store/slices/apiSlice/map-api-slice';

import Page from '../page';
import RealEstateMarketTabs from './realEstateMarketTabs';
import './realEstateMarketDashboard.css';

function RealEstateMarketDashboard() {
    const cities = useAppSelector(selectCities);
    const [getMapInitData] = useLazyGetMapInitDataQuery();

    useEffect(() => {
        if (!cities || !cities.length) {
            getMapInitData();
        }
    });

    return (
        <Page>
            <div className="container-fluid pb-3 ps-0 ps-md-4 pe-2">
                <div className="row">
                    <div className="col-12">
                        <h1 className="fs-1 lh-1 text-capitalize mb-1">
              Real Estate Market
                        </h1>
                    </div>
                    <div className="col-12">
                        <RealEstateMarketTabs />
                    </div>
                </div>
            </div>
        </Page>
    );
}

export default RealEstateMarketDashboard;
